import { v4 as uuidv4 } from 'uuid';

export default class FinestHourAircraft {
  toPOJO() {
    return JSON.stringify({
      id: this.id,
      minorDamages: this.minorDamages,
      seriousDamages: this.seriousDamages,
      isDestroyed: this.isDestroyed,
      isUnderRepair: this.isUnderRepair,
    });
  }

  static fromPOJO(pojo) {
    return new FinestHourAircraft(JSON.parse(pojo));
  }

  constructor({
    id = uuidv4(),
    minorDamages = [],
    seriousDamages = [],
    isDestroyed = false,
    isUnderRepair = false,
  } = {
    id: uuidv4(),
    minorDamages: [],
    seriousDamages: [],
    isDestroyed: false,
    isUnderRepair: false,
  }) {
    this.id = id;
    this.minorDamages = minorDamages;
    this.seriousDamages = seriousDamages;
    this.isDestroyed = isDestroyed;
    this.isUnderRepair = isUnderRepair;
  }

  get isActive() {
    return !this.isDestroyed
      && !this.isUnderRepair;
  }
}
